export enum CrmEntityQueryKey {
  GetEntityByFieldQuery = 'getEntityByFieldQuery'
}
